<template>
  <div>
    <span id="trigger-anchor"></span>
    <el-popover v-bind="$attrs" placement="top" trigger="click" v-on="$listeners">
      <slot></slot>
      <div slot="reference">
        <slot name="ref"></slot>
      </div>
    </el-popover>
  </div>
</template>

<script>
function simulateClick(btn) {
  const event = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  })

  btn.dispatchEvent(event)
}
export default {
  props: {},
  data() {
    return {}
  },
  methods: {
    /**
     * @description: el-popover 模拟点击事件关闭popover
     */
    close() {
      this.$nextTick(() => {
        const btn = document.querySelector('#trigger-anchor')
        simulateClick(btn)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
